import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import React from "react";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";

const ProgressDisplay = ({
    label,
    mark,
    fromMentor
}) => {
    return (
        <CommonCard
            borderRadius={1}
            paddingBottom="0px"
            background={fromMentor ? '#FAFAFA' : 'white'}
            content={
                <Box display="flex" gap={1} alignItems="center">
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            size={50}
                            thickness={6}
                            sx={{
                                color: '#e0e0e0', // Light gray for remaining portion
                                position: 'absolute',
                                '& .MuiCircularProgress-circle': {
                                    strokeLinecap: 'round',
                                },
                            }}
                        />
                        <CircularProgress
                            variant="determinate"
                            value={mark}
                            size={50}
                            thickness={6}
                            sx={{
                                color: mark >= 85
                                    ? theme.palette.secondary.default
                                    : mark >= 50
                                        ? theme.palette.primary.main
                                        : mark > 0
                                            ? 'red'// Full green
                                            : theme.palette.secondary.default, // Your progress color
                                '& .MuiCircularProgress-circle': {
                                    strokeLinecap: 'round',
                                },
                            }}
                        />
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography
                                fontSize={12}
                                component="div"
                                fontWeight={700}
                                color="text.primary"
                            >
                                {`${mark}%`}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography fontWeight={600}>{label}</Typography>
                </Box>
            }
        />
    )
}

const ProgrssBar = ({
    progressData,
    fromMentor
}) => {
    return (
        <Grid container spacing={2}>
            <Grid item md={4}>
                <ProgressDisplay
                    label="Assignment"
                    mark={progressData?.assignments_avg}
                    fromMentor={fromMentor}
                />
            </Grid>
            <Grid item md={4}>
                <ProgressDisplay
                    label="Tests"
                    mark={progressData?.tests_avg}
                    fromMentor={fromMentor}
                />
            </Grid>
            <Grid item md={4}>
                <ProgressDisplay
                    label="Quizzes"
                    mark={progressData?.quizzes_avg}
                    fromMentor={fromMentor}
                />
            </Grid>
        </Grid>
    )
}

export default ProgrssBar;